import { jsonMember, jsonObject } from 'typedjson';

@jsonObject()
export class ActivePricingPlan {
    // isSystemTrial: boolean;
    @jsonMember(String)
    _id: string;
    @jsonMember(String)
    name: string;
    @jsonMember(String)
    stripeProductId: string;
    @jsonMember(Number)
    planPrice: number;
    @jsonMember(Number)
    additionalAppointmentPrice: number;
    // @jsonMember(String)
    // stripePriceId: string[];
    @jsonMember(Boolean)
    isActive: boolean;
    @jsonMember(Boolean)
    isDeleted: boolean;
    @jsonMember(String)
    businessIndustry: string;
    @jsonMember(Number)
    planAppointments: number;
    @jsonMember(String)
    createdAt: string;
    @jsonMember(String)
    updatedAt: string;
    @jsonMember(Number)
    __v: number;
}
